<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="5">
          <div class="cdtitle">交通住宿</div>
          <el-menu @select="handleSelect" :default-active="pageNum" class="gyzhcd  el-menu-vertical-demo" text-color="#000" active-text-color="#1D50A2">
            <el-menu-item index="1">展馆交通</el-menu-item>
            <el-menu-item index="2">周边住宿</el-menu-item>
          </el-menu>
          <!-- 相关文章 -->
          <!-- <div>
            <div style="font-size: 24px;color: #2D67B6;letter-spacing: 0;line-height: 22px;font-weight: 600;margin-top:25px;padding-bottom:15px;border-bottom: 3px #1D50A2 solid ;">相关文章</div>
            <div class="xgtitle">关于要求参加第二十二届中国国际关于要求参加第二十二届中国国际关于要求参加第二十二届中国国际</div>
            <div class="address">
              主办单位：中国环境保护产业协会<br />
              地址：北京中国国际展览中心
              （朝阳馆）<br />
              日期：2025年4月10日-12日
            </div>
          </div> -->
          <!-- 展出时间 -->
          <div class="zcsj">
            展出时间
          </div>
          <div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月2日 9：00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月3日 9：00-17:00
              </div>
            </div>
            <div class="rqys">
              <div class="greendian"></div>
              <div class="rcsj">
                2026年6月4日 9：00-16:00
              </div>
            </div>
            <div style="margin-bottom:30px" class="rcsj">
              （每日闭馆前1小时停止入场）
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>配套服务>></div>
            <div>{{menuName}}</div>
          </div>
          <div v-if="menuName=='展馆交通'||pageNum==1">
            <h2>中国国际展览中心（朝阳馆）</h2>
            <p>北京朝阳区北三环东路6号&nbsp;&nbsp;&nbsp; 邮编:100028</p>
            <div class="jt">
              <img style="width:100%" src="../../assets/index/jt-20251226.png" alt="">
            </div>
            <!-- <div class="jt">
              <img style="width:1000px" src="../../assets/index/cy.png" alt="">
            </div> -->
          </div>
          <div style="margin-bottom:20px" v-if="menuName=='周边住宿'||pageNum==2">
            <div class="zbzs">
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd1.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京皇家格兰云天大酒店</span>
                  <span>⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离展馆200米</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/detail/?hotelId=429073&checkIn=2023-08-30&checkOut=2023-08-31&cityId=1&minprice=&mincurr=&adult=2&children=1&ages=6&crn=1&curr=&fgt=&stand=&stdcode=&hpaopts=&mproom=&ouid=&shoppingid=&roomkey=&highprice=-1&lowprice=0&showto">
                    <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button>
                  </a>

                </div>
              </div>
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd2.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京望京凯悦酒店</span>
                  <span>⭐⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（朝阳馆）4.5公里，车行约17分钟</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/19453785.html?isFull=F&showflagship=hyatt&masterhotelid=19453785&hcityid=1#ctm_ref=hod_sr_lst_dl_n_1_1"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
            </div>
            <div class="zbzs">
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd3.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京维景国际大酒店</span>
                  <span>⭐⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（朝阳馆）762米，步行约11分钟</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/4889269.html?isFull=F&masterhotelid=4889269&hcityid=1#ctm_ref=hod_sr_lst_dl_n_1_1"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd4.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京新云南皇冠假日酒店</span>
                  <span>⭐⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（朝阳馆）1.9公里，车行约26分钟</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/430265.html#ctm_ref=hod_hp_sb_lst"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
            </div>
            <div class="zbzs">
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd5.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京中航泊悦酒店</span>
                  <span>⭐⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（朝阳馆）4.7公里，车行约17分钟</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/375098.html?isFull=F"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd6.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京亮马河饭店</span>
                  <span>⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（静安庄馆） 2.6公里，乘车约10分钟</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/467325.html#ctm_ref=ctr_hp_sb_lst"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
            </div>
            <div class="zbzs">
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd7.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">北京重庆饭店</span>
                  <span>⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距离国际展览中心（朝阳馆）步行1公里</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/detail/?hotelId=448716&checkIn=2022-06-13&checkOut=2022-06-17&cityId=1&minprice=&mincurr=&adult=1&children=0&ages=&crn=1&curr=&fgt=&stand=&stdcode=&hpaopts=&mproom=&ouid=&shoppingid=&roomkey=&highprice=-1&lowprice=0&showtot"> <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>

                </div>
              </div>
              <div style="background-color:#fcfcfc">
                <div>
                  <img style="width:500px;height:300px" src="../../assets/index/jd8.jpg" alt="">
                </div>
                <div>
                  <span style="font-size:20px;margin:10px 0;display:inline-block">格林豪泰（北京国展三元西桥店）</span>
                  <span>⭐⭐⭐⭐</span>
                </div>
                <div style="font-size:20px;margin:10px 0 20px 0;">距中国国际展览中心（静安庄馆）步行800米</div>
                <div>
                  <a href="https://hotels.ctrip.com/hotels/detail/?hotelId=1786321&checkIn=2022-06-13&checkOut=2022-06-17&cityId=1&minprice=&mincurr=&adult=1&children=0&ages=&crn=1&curr=&fgt=&stand=&stdcode=&hpaopts=&mproom=&ouid=&shoppingid=&roomkey=&highprice=-1&lowprice=0&showto">   <el-button style="width:100%;height:50px;font-size:18px" type="success">点击预定</el-button></a>
                </div>
              </div>
            </div>

          </div>

        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '展馆交通',
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;

}
.bigbgi { background-image: url("../../assets/index/banner-2026.jpg"); background-repeat: no-repeat; background-position: center top; background-size: cover; width: 100%; height: 0; padding-bottom: 27.87%; margin-bottom: 60px; }
.midbgi { background-image: none; width: 100%; }
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
p {
  text-align: center;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.jt {
  /* display: flex; */
  margin: 0 auto;
  text-align: center;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}
.zhzl {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 45px;
}
h2 {
  text-align: center;
}

.dwname {
  font-size: 18px;
  font-weight: normal;
  margin: 0 30px;
  line-height: 25px;
}
.zbzs {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/ptfw.vue